import { useEffect } from 'react';
import { annotationPluginKey, coordsAtPos } from '../../editor-core';
import {
  ANNOTATABLE_SELECTION_EVENT,
  ANNOTATABLE_SELECTION_CLEAR_EVENT,
  ACTIVATE_ANNOTATION_EVENT
} from '../api';

function useAnnotationPlugin(
  editorReady,
  editorViewRef,
  editorState,
  consumerApi,
  historyMode
) {
  const pluginState = editorReady && editorState && annotationPluginKey.getState(editorState);
  const {
    activeAnnotation,
    activeAnnotationRange,
    annotatableSelectionRange,
    highlightedText
  } = pluginState || { annotatableSelectionRange: {}, activeAnnotationRange: {} };

  // Trigger Annotatable selection events
  useEffect(() => {
    if (annotatableSelectionRange.from) {
      const coords = coordsAtPos(
        editorViewRef.current,
        annotatableSelectionRange.from
      );
      consumerApi.emit(ANNOTATABLE_SELECTION_EVENT, { coords, highlightedText });
    }
    else {
      consumerApi.emit(ANNOTATABLE_SELECTION_CLEAR_EVENT, {});
    }
  }, [annotatableSelectionRange.from, highlightedText, editorViewRef, consumerApi]);

  // Trigger Annotation activated event
  useEffect(() => {
    if (activeAnnotation && !historyMode) {
      if (activeAnnotation) {
        const coords = coordsAtPos(editorViewRef.current, activeAnnotationRange.from);
        consumerApi.emit(ACTIVATE_ANNOTATION_EVENT, {
          annotationUUID: activeAnnotation,
          coords
        });
      } else {
        consumerApi.emit(ACTIVATE_ANNOTATION_EVENT, {
          uuid: null,
          coords: { top: null, bottom: null, left: null, right: null }
        });
      }
    }
  }, [activeAnnotation, historyMode, activeAnnotationRange.from, consumerApi, editorViewRef]);
}

export default useAnnotationPlugin;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/hooks/useAnnotationPlugin.js